import { create } from 'zustand';
import apiClient from '../lib/api';

export interface Expense {
  id: string;
  employee_id: string;
  first_name?: string;
  last_name?: string;
  amount: number;
  category: string;
  description: string;
  expense_date: string;
  receipt_url?: string;
  status: 'pending' | 'approved' | 'rejected' | 'paid' | 'submitted';
}

interface ExpenseState {
  expenses: Expense[];
  isLoading: boolean;
  error: string | null;
  
  fetchExpenses: () => Promise<void>;
  createExpense: (data: Partial<Expense>) => Promise<void>;
  approveExpense: (id: string) => Promise<void>;
}

export const useExpenseStore = create<ExpenseState>((set) => ({
  expenses: [],
  isLoading: false,
  error: null,

  fetchExpenses: async () => {
    set({ isLoading: true, error: null });
    try {
      const response = await apiClient.get('/money/expenses');
      set({ expenses: response.data, isLoading: false });
    } catch (error: any) {
      set({ error: error.message, isLoading: false });
    }
  },

  createExpense: async (data: Partial<Expense>) => {
    set({ isLoading: true, error: null });
    try {
      const response = await apiClient.post('/money/expenses', data);
      set((state) => ({
        expenses: [response.data, ...state.expenses],
        isLoading: false
      }));
    } catch (error: any) {
      set({ error: error.message, isLoading: false });
      throw error;
    }
  },

  approveExpense: async (id: string) => {
    set({ isLoading: true, error: null });
    try {
      const response = await apiClient.patch(`/money/expenses/${id}/approve`);
      set((state) => ({
        expenses: state.expenses.map((e) => (e.id === id ? response.data : e)),
        isLoading: false
      }));
    } catch (error: any) {
      set({ error: error.message, isLoading: false });
      throw error;
    }
  }
}));
